export function handleBookingSubmission(elem) {
    if (!elem) return;

    const storageKey = 'userPostcode';

    const form = elem.querySelector('.postcode-form');
    const input = elem.querySelector('.postcode-input');
    const confirmation = elem.querySelector('.postcode-confirmation');
    const display = elem.querySelector('.postcode-display');

    const confirmYes = elem.querySelector('[data-postcode-confirm="postcode-confirm-yes"]');
    const confirmNo = elem.querySelector('[data-postcode-confirm="postcode-confirm-no"]');

    if (!form || !input || !confirmation || !display) return;

    function normalisePostcode(value) {
        return value.trim().toUpperCase().replace(/\s+/g, '');
    }

    function isValidPostcode(postcode) {
        const ukPostcodeRegex = /^([A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2})$/;
        return ukPostcodeRegex.test(postcode);
    }

    function resetPostcodeForm() {
        form.reset();
        input.removeAttribute('aria-invalid');
        confirmation.hidden = true;
        form.hidden = false;
        input.focus();
    }

    form.addEventListener('submit', (event) => {
        event.preventDefault();

        const postcode = normalisePostcode(input.value);

        if (!isValidPostcode(postcode)) {
            input.setAttribute('aria-invalid', 'true');
            input.focus();
            return;
        }

        input.removeAttribute('aria-invalid');

        // Show confirmation UI
        display.textContent = postcode;
        form.hidden = true;
        confirmation.hidden = false;
        confirmYes.focus();
    });

    confirmYes.addEventListener('click', () => {
        localStorage.setItem(storageKey, display.textContent);
        confirmation.hidden = true;
        document.body.classList.add('postcode-confirmed');
    });

    confirmNo.addEventListener('click', resetPostcodeForm);
}